module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 292);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/popover.css");

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return submitPrivateInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpLogin; });
/* unused harmony export httpPostAnswerRecord */
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
// 部署版相关接口

let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

// 提交部署版需求登记
// eslint-disable-next-line import/prefer-default-export
function submitPrivateInfo(data) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/plugin/api/v1/deploy_version/try/", data);
}

/**
 * 登录(部署版)
 * @param {object} params
 * @returns
 */
function httpLogin(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/deployment/member/login/", params);
}

// 接口调用答题结束页引导, 新增自己的答题数据
function httpPostAnswerRecord(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/app_api/common/api/answer_record/", params);
}

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dialog.css");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/input.css");

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/private-form/src/index.vue?vue&type=template&id=5eecd544&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wd-dialog",
    {
      attrs: {
        visible: _vm.isShow,
        width: "500px",
        "append-to-body": "",
        "close-on-click-modal": false,
        "custom-class": "private-form-dialog"
      },
      on: { close: _vm.handleClose }
    },
    [
      _c(
        "span",
        { attrs: { slot: "title" }, slot: "title" },
        [
          _c("span", [_vm._v("部署版需求登记")]),
          _vm._v(" "),
          _c(
            "wd-popover",
            {
              staticClass: "custom-service",
              attrs: {
                width: "120",
                placement: "bottom-end",
                "popper-class": "private-service-popper",
                trigger: "hover",
                "append-to-body": false
              }
            },
            [
              _c("span", { staticClass: "contact-info" }, [
                _c("span", [_vm._v("咨询电话")]),
                _vm._v(" "),
                _c("span", { staticClass: "phone" }, [_vm._v("15921419095")]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "service-btn", on: { click: _vm.gotoQiyu } },
                  [_vm._v("专属客服")]
                )
              ]),
              _vm._v(" "),
              _c("span", { attrs: { slot: "reference" }, slot: "reference" }, [
                _c("i", { staticClass: "svg-icon message-icon" }),
                _vm._v(" "),
                _c("span", { staticClass: "contact-us" }, [_vm._v("联系我们")])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "content-title" }, [
        _vm._v("请您登记相关信息，我们会尽快与您联系")
      ]),
      _vm._v(" "),
      _c(
        "wd-form",
        {
          ref: "privateForm",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-position": "top"
          }
        },
        [
          _c(
            "wd-form-item",
            { attrs: { label: "企业名称", prop: "entName" } },
            [
              _c("wd-input", {
                attrs: {
                  type: "text",
                  maxlength: "50",
                  size: "small",
                  placeholder: "请填写企业名称"
                },
                model: {
                  value: _vm.formData.entName,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "entName", $$v)
                  },
                  expression: "formData.entName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "wd-form-item",
            { attrs: { label: "如何称呼您", prop: "name" } },
            [
              _c("wd-input", {
                attrs: {
                  type: "text",
                  size: "small",
                  maxlength: "20",
                  placeholder: "请填写称呼"
                },
                model: {
                  value: _vm.formData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "name", $$v)
                  },
                  expression: "formData.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "wd-form-item",
            { attrs: { label: "您的职务", prop: "job" } },
            [
              _c("wd-input", {
                attrs: {
                  type: "text",
                  size: "small",
                  maxlength: "20",
                  placeholder: "请填写职务"
                },
                model: {
                  value: _vm.formData.job,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "job", $$v)
                  },
                  expression: "formData.job"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "wd-form-item",
            [
              _c(
                "wd-button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: { click: _vm.handleSubmit }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/private-form/src/index.vue?vue&type=template&id=5eecd544&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/input.css"
var input_css_ = __webpack_require__(20);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/input"
var input_ = __webpack_require__(9);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/popover.css"
var popover_css_ = __webpack_require__(125);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/popover"
var popover_ = __webpack_require__(52);
var popover_default = /*#__PURE__*/__webpack_require__.n(popover_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/form-item.css"
var form_item_css_ = __webpack_require__(62);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/form-item"
var form_item_ = __webpack_require__(39);
var form_item_default = /*#__PURE__*/__webpack_require__.n(form_item_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/form.css"
var form_css_ = __webpack_require__(63);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/form"
var form_ = __webpack_require__(40);
var form_default = /*#__PURE__*/__webpack_require__.n(form_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(8);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/button"
var button_ = __webpack_require__(3);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(16);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dialog"
var dialog_ = __webpack_require__(7);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// EXTERNAL MODULE: ./src/http/private/index.js
var http_private = __webpack_require__(144);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/private-form/src/index.vue?vue&type=script&lang=js&













/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "PrivateForm",
  components: {
    "wd-dialog": dialog_default.a,
    "wd-button": button_default.a,
    "wd-form": form_default.a,
    "wd-form-item": form_item_default.a,
    "wd-popover": popover_default.a,
    "wd-input": input_default.a
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        entName: "",
        name: "",
        job: ""
      },
      rules: {
        entName: [{
          required: true,
          message: "请填写企业名称",
          trigger: "change"
        }],
        name: [{
          required: true,
          message: "请填写称呼",
          trigger: "change"
        }],
        job: [{
          required: true,
          message: "请填写职务",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    gotoQiyu() {
      window.ysf && window.open(window.ysf("url"));
    },
    handleSubmit() {
      this.$refs.privateForm.validate(valid => {
        if (valid) {
          Object(http_private["b" /* submitPrivateInfo */])({
            enterprise_name: this.formData.entName,
            user_name: this.formData.name,
            post: this.formData.job
          }).then(res => {
            if (res.status_code === 1) {
              this.$message({
                message: "提交成功",
                type: "success"
              });
              this.handleClose();
            } else {
              this.$message({
                message: res.err_msg,
                type: "error"
              });
            }
          });
          return false;
        }
      });
    },
    handleClose() {
      this.$emit("update:isShow", false);
    }
  }
});
// CONCATENATED MODULE: ./packages/private-form/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var private_form_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/private-form/src/index.vue?vue&type=style&index=0&id=5eecd544&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/private-form/src/index.vue?vue&type=style&index=0&id=5eecd544&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/private-form/src/index.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  private_form_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "5eecd544",
  null
  
)

/* harmony default export */ var src = (component.exports);
// CONCATENATED MODULE: ./packages/private-form/index.js


// eslint-disable-next-line func-names
src.install = function (Vue) {
  Vue.component(src.name, src);
};
/* harmony default export */ var private_form = __webpack_exports__["default"] = (src);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/button");

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/form-item");

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/form");

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/popover");

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/form-item.css");

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/form.css");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dialog");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/button.css");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/input");

/***/ })

/******/ })["default"];